
import { defineComponent, reactive } from "vue";
import PageFrame from "@/components/common/PageFrame.vue";
import RequestNormal from "@/components/common/Request/RequestNormal.vue";
import RequestQuick from "@/components/common/Request/RequestQuick.vue";

enum PageTypes {
  "NORMAL",
  "QUICK",
  "SELECT",
}

export default defineComponent({
  props: {
    hospitalKey: {
      type: Number,
      required: false,
    },
  },
  setup(props) {
    const state = reactive({
      pageType: PageTypes.SELECT,
      selectedHospital: props.hospitalKey,
    });

    const selectQuick = () => {
      if (state.pageType !== PageTypes.QUICK) state.pageType = PageTypes.QUICK;
    };
    const selectNormal = () => {
      if (state.pageType !== PageTypes.NORMAL)
        state.pageType = PageTypes.NORMAL;
    };

    return {
      state,
      PageTypes,
      selectNormal,
      selectQuick,
    };
  },
  components: {
    PageFrame,
    RequestNormal,
    RequestQuick,
  },
});
